// extracted by mini-css-extract-plugin
module.exports = {"image":"CardImage_image__3qYje","image_link":"CardImage_image_link__1PyS7"};